<div class="row">
  <div class="col">
    <div widget class="card border-0 box-shadow">
      <div class="card-header transparent text-muted">
        <h4 class="mb-2 py-1 font-header-1"> Agency Report</h4>
      </div>
      <div class="card-body  widget-body pb-0 pt-3 mb-4">
        <div class="row col-lg-12">
          <div class="col-lg-1 me-1 mb-2">

            <button type="button" class="btn btn-sm" (click)="exceldownload()">
              <i class="fa fa-download"> </i>Excel
            </button>
          </div>

          <div class="col-lg-1 me-1 mb-2">
            <button type="button" class="btn btn-sm" (click)="pdfdownload()">
              <i class="fa fa-download"> </i>PDF
            </button>
          </div>
          <div class="col-lg-1">
            <label>Start
              Date<sup class="super-script">*</sup></label>
          </div>
          <div class="col-lg-2 me-1 col-11">
            <my-date-picker class="w-100" [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
              [selDate]="AgencysendBO.start" (inputFieldChanged)="DateFormat($event,'inputchanged','SaveFromDate')"
              (dateChanged)="DateFormat($event,'datechanged','SaveFromDate')">
            </my-date-picker>
          </div>
          <div class="col-lg-1">
            <label>End
              Date<sup class="super-script">*</sup></label>
          </div>
          <div class="col-lg-2 me-1 col-11">
            <my-date-picker class="w-100" [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
              [selDate]="AgencysendBO.end" (inputFieldChanged)="DateFormat($event,'inputchanged','SaveEndDate')"
              (dateChanged)="DateFormat($event,'datechanged','SaveEndDate')">
            </my-date-picker>
          </div>


          <div class="col-lg-3 text-end">
            <div>
              <button type="button" class="btn btn-sm  me-2" (click)="ApplyFilter()">Apply
              </button>
              <button class="btn  btn-sm" (click)="Refresh()">
                <i class="fa fa-repeat"> Refresh </i>
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row mb-2 pt-2">
  <div class="col-lg-12 pl-0">
    <div widget class="card border-0 box-shadow">
      <div class="card-body  widget-body pt-2">
        <div class="container-fluid">
          <ejs-grid #grid class="w-100" [dataSource]='data | async' [allowResizing]='true' [allowSorting]='true'
            allowPaging='true' [allowFiltering]='false' [pageSettings]='initialPage' [allowExcelExport]='true'
            [allowPdfExport]='true' (actionBegin)="onActionComplete($event)" [showColumnChooser]='false'
            [filterSettings]='filterSettings' [showColumnChooser]='false' (dataStateChange)='dataStateChange($event)'>

            <e-columns>
              <e-column minWidth=50 field="agencyName" headerText="Name" type="string">
              </e-column>

              <e-column minWidth=100 field="activeClientWithTimesheet" textAlign='Center'
                headerText="Active Client With Timesheet">
              </e-column>

              <e-column minWidth=100 field="activeClientWithoutTimesheet" textAlign='Center'
                headerText="Active Client Without Timesheet">
              </e-column>

              <e-column minWidth=100 field="inactiveClientWithTimesheet" textAlign='Center'
                headerText="Inactive Client With Timesheet">
              </e-column>

              <e-column minWidth=100 field="inactiveClientWithoutTimesheet" textAlign='Center'
                headerText="Inactive Client Without Timesheet">
              </e-column>

              <e-column minWidth=80 field="location" textAlign='Center' headerText="Location">
              </e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </div>
    </div>
  </div>
</div>